import React from 'react'
import Box from '@ui/Box'
import IconButton from '@ui/IconButton'
import { AnalyticsEvents, sendAnalyticsEvent } from '@utils/analytics'
import { withHandledErrors } from '@utils/errors'
import { requestHelp, useGetProfile } from '@api/users'
import { useNotification } from '@ui/NotificationProvider'

type Props = {
  label?: string
  children?: React.ReactNode
  onClick?: () => void
  small?: boolean
}

const HelpButton = ({
  label = 'I need some help with the product',
  children,
  onClick,
  small,
}: Props) => {
  const { data: profile } = useGetProfile()
  const [loading, setLoading] = React.useState(false)
  const notification = useNotification()
  const [sent, setSent] = React.useState(false)

  const onHelpClick = async () => {
    sendAnalyticsEvent(AnalyticsEvents.helpRequestClicked)
    setLoading(true)

    await withHandledErrors(
      notification,
      async () => {
        await requestHelp()
        setLoading(false)
        onClick?.()
        setSent(true)
      },
      'We have received your request and aim to contact you in 1 working day.',
      'Failed to send the request. Please try again later, or contact us directly at inbox@enhanci.com',
    )
  }

  return (
    <Box>
      <Box mt={24} mb={8}>
        {children || (
          <>
            If you don't know what to do next or need any help, click here and our
            friendly team will be in touch by the email ({profile?.email || ''})
          </>
        )}
      </Box>
      <IconButton
        type="primary"
        onClick={onHelpClick}
        size={small ? undefined : 'large'}
        loading={loading}
        disabled={sent}
      >
        {label}
      </IconButton>
    </Box>
  )
}

export default HelpButton
